module.exports = __webpack_public_path__ + "static/media/280744.df0869cd.png";